import React, { Fragment } from "react";
import {
  Copy,
  Hero,
  NavItem,
  SectionFull,
  Sidebar,
  Image,
  variables,
} from "@website2018/da-dobsonville";
import { Link } from "react-router-dom";
import { noComma } from "../../common/utils";

import Asides from "../Asides/Asides";
import SubMenu from "../Nav/SubMenu";
import Layout from "../Layout/Base";
import Actions from "../Actions/Actions";

import Sticky from "react-stickynode";
import YouTubeVideo from "../Videos/YouTubeVideo";

const GNUTemplate = (props) => {
  const { page: p } = props;

  const portfolios = props.portfolios.map(p => ({...p, priority: p.acf.minister_name.startsWith('Minister') ? 1 : 2}))
    .sort((a, b) => {
      return a.priority - b.priority || (a.title.rendered > b.title.rendered ? 1 : -1);
    });

  const podcasts = props.portfolios
    .filter(pf => pf.acf.podcast && pf.acf.podcast.podcast_url != '')
    .map(pf => {
      const url = pf.acf.podcast.podcast_url;
      const videoId = new URL(url).searchParams.get("v");
      return {
        title: pf.acf.podcast.podcast_title,
        url,
        videoId
      }
    })
    .sort((a, b) => a.title > b.title ? 1 : -1);

  const { colors, fontWeight } = variables;

  return [
    <Sticky enabled={true} top={"#mainNav"} innerZ="9998">
      {p.parent && (
        <SubMenu>
          <NavItem
            fontWeight={fontWeight.medium}
            color={colors.textBase}
            fs={"13px"}
            lh={"16px"}
          >
            <Link to={`/${p.parent.slug}`}>{p.parent.title.rendered}</Link>
          </NavItem>
          {p.parent.children &&
            p.parent.children.map((c) => (
              <NavItem
                fontWeight={fontWeight.medium}
                color={colors.linkBlue}
                fs={"13px"}
                lh={"16px"}
              >
                <Link to={`/${p.parent.slug}/${c.slug}`}>
                  {c.title.rendered}
                </Link>
              </NavItem>
            ))}
        </SubMenu>
      )}
    </Sticky>,
    <Hero
      imageUrl={
        p.hero && p.hero.background_image ? p.hero.background_image.url : null
      }
      title={p.hero && p.hero.headline ? p.hero.headline : p.title.rendered}
      bgPosition={p.hero && p.hero.focus_point && noComma(p.hero.focus_point)}
      mb={
        p.hero && p.hero.background_image && p.hero.background_image.url
          ? "large"
          : "none"
      }
      center={p.hero && p.hero.cta_type === "Countdown" ? true : null}
    >
      {p.hero.cta_type === "Countdown" ? (
        <Actions
          type={p.hero.cta_type}
          headline={p.hero.countdown.headline}
          date={p.hero.countdown.date}
          label={
            p.acf.hero.button &&
            p.acf.hero.button.link_label &&
            p.acf.hero.button.link_label
          }
          color={
            p.acf.hero.button &&
            p.acf.hero.button.link_color &&
            p.acf.hero.button.link_color
          }
          target={
            p.acf.hero.button &&
            p.acf.hero.button.link_target &&
            p.acf.hero.button.link_target
          }
          url={
            p.acf.hero.button &&
            p.acf.hero.button.link_url &&
            p.acf.hero.button.link_url
          }
        />
      ) : null}
    </Hero>,
    <Fragment>
      {p.content.rendered && (
        <SectionFull mt={"none"} mb={"medium"}>
          <div className={"col-lg-7"}>
            <article className="entry">
              <Copy intro html={p.content.rendered} />
            </article>
          </div>

          <Sidebar>{p.asides && <Asides asides={p.asides} />}</Sidebar>
        </SectionFull>
      )}
    </Fragment>,
    <Fragment>
      <SectionFull mt={"none"} mb={"medium"} title="A party of national government, rescuing South Africa">
        <div className="col-12">
          <div className="row">
            {portfolios.map(pf => (
              <div className="col-lg-6 p-2" key={pf.slug}>
                <div style={{float: 'right', width: 200}}>
                  <Image imageUrl={pf.acf && pf.acf.minister_image && pf.acf.minister_image.sizes.medium_large} />
                </div>
                <div style={{ fontFamily: "'Bebas Neue', serif", fontStyle: "italic", fontWeight: "bold", fontSize: '16pt' }}>
                  <div dangerouslySetInnerHTML={{ __html: pf.title.rendered }} />
                </div>
                <div style={{ fontFamily: "'Roboto Condensed', sans-serif", fontWeight: "bold", fontSize: '14pt', color: 'rgb(21, 95, 162)' }}>
                  {pf.acf && pf.acf.minister_name}
                </div>
                <hr style={{ width: 'calc(100% - 220px)', marginLeft: '10px' }} />
                <Copy intro html={pf.content.rendered} />
              </div>
            ))}
          </div>
        </div>
      </SectionFull>
    </Fragment>,
    <Fragment>
      <SectionFull mt={"none"} mb={"medium"} title="Get to know our Ministers">
        <div className="col-12">
          <div className="row">
            {podcasts.map(pc => (
              <div className="col-lg-6 p-2" key={pc.podcast_url}>
                <div style={{ fontFamily: "'Roboto Condensed', sans-serif", fontWeight: "bold", fontSize: '14pt' }}>
                  {pc.title}
                </div>
                <YouTubeVideo videoId={pc.videoId} />
              </div>
            ))}
          </div>
        </div>
      </SectionFull>
    </Fragment>,
    <Fragment>
      <SectionFull mt={"none"}>
        <div className={"col-lg-7"} style={{ margin: '0 auto' }}>
          <article className="entry">
            {p.acf.layout_content && p.acf.layout_content.length ? (
              <Layout layout={p.acf.layout_content} />
            ) : null}
          </article>
        </div>
      </SectionFull>
    </Fragment>,
  ];
};

export default GNUTemplate;
